import * as React from "react";
const IconStatsUp = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M60 57.8H6.3V4c0-1.2-1-2.3-2.3-2.3S1.8 2.8 1.8 4v54.1c0 2.3 1.9 4.2 4.2 4.2h54c1.2 0 2.3-1 2.3-2.3s-1.1-2.2-2.3-2.2" />
    <path d="M59 22.1H47.3c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h6.8l-5.3 4.6H35.7c-.7 0-1.4.3-1.8.9l-7.1 9.3H16.3c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h11.6c.7 0 1.4-.3 1.8-.9l7.1-9.3h12.9c.5 0 1.1-.2 1.5-.6l6.6-5.8v7.7c0 1.2 1 2.3 2.3 2.3s2.3-1 2.3-2.3V25.3c-.1-1.7-1.6-3.2-3.4-3.2" />
  </svg>
);
export default IconStatsUp;
